import styled from "styled-components";

export const PerformanceEditorWrapper = styled.div`
  padding: ${(props) => props.padding || "none"};
`;

export const CreativesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: -3px;
`;

export const RemoveButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  background: white;
  opacity: 0.4;
  color: #333333;
  border: none;
  padding: 0;
  width: 17px;
  display: flex;
  border-radius: 0 2px 0 3px;
  transition: all 0.15s;
  &:hover {
    opacity: 0.9 !important;
  }
`;

export const CreativeWrapper = styled.div`
  position: relative;
  height: 42px;
  width: 60px;
  border: 2px solid ${(props) => (props.selected ? "#1e22ff" : "#e8e8eb")};
  cursor: pointer;
  margin: 3px;
  border-radius: 4px;
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  transition: all 0.15s;
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 16px 0 #1516331a;
    ${RemoveButton} {
      opacity: 0.6;
    }
    video {
      transform: scale(1.01);
    }
  }
`;

export const EditButton = styled.button`
  width: 100%;
  background-color: #e9e9ff;
  display: flex;
  justify-content: center;
  color: #1e22ff;
  border: none;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  border-radius: 4px;
  align-items: center;
  height: 42px;
  &:hover {
    background-color: #dfdff5;
  }
`;
